import api from '../shared/services/api';

export interface ModelPerformance {
  avgResponseTime: number;
  accuracy: number;
  totalAnalyses: number;
}

export interface AiModel {
  modelId: string;
  displayName: string;
  description: string;
  available: boolean;
  performance: ModelPerformance;
}

export interface CurrentModelResponse {
  currentModel: string;
  config: AiModel;
}

class AiModelService {
  async getAvailableModels(): Promise<AiModel[]> {
    const response = await api.get('/admin/ai/models');
    return response.data;
  }

  async getCurrentModel(): Promise<CurrentModelResponse> {
    const response = await api.get('/admin/ai/models/current');
    return response.data;
  }

  async setCurrentModel(modelId: string): Promise<{ message: string; currentModel: string }> {
    const response = await api.post('/admin/ai/models/current', { modelId });
    return response.data;
  }

  async testModel(modelId: string): Promise<{ modelId: string; available: boolean; message: string }> {
    const response = await api.post(`/admin/ai/models/${modelId}/test`);
    return response.data;
  }

  async getModelConfig(modelId: string): Promise<AiModel> {
    const response = await api.get(`/admin/ai/models/${modelId}`);
    return response.data;
  }
}

export default new AiModelService();
